<template>
  <div>
    <div
      @click="focusNewTag()"
      :class="{
        'read-only': readOnly,
        'vue-input-tag-wrapper--active': isInputActive,
        'is-disable': disabled,
      }"
      :id="id"
      class="vue-input-tag-wrapper"
      ref="MultiInputTag"
    >
      <div v-if="innerTags.length > 0" class="input-tags-box" :style="inputTagsbox()" ref="tagsBox">
        <span v-for="(tag, index) in innerTags" ref='tags' :key="index" :class="{'select-tag': checkedTagIndex==index}" class="input-tag" @mousedown.prevent.stop="handleCheckTag(tag, index)" @dblclick="dblclick">
          <span class="views_tag" v-if="showSearchType"><span>{{ tag.type }} | </span>{{ tag.value }}</span>
          <span class="views_tag" v-else>{{ tag }}</span>
          <a v-if="!readOnly" @mousedown.prevent.stop="remove(index)" class="remove">
            <i class="el-icon-close newIcon"></i>
          </a>
        </span>
      </div>
      <input
        ref="inputtag"
        :readonly="readOnly"
        :disabled="disabled"
        :placeholder="innerTags.length?'':placeholder"
        type="text"
        v-model="newTag"
        @input="handleInput"
        v-on:keydown.delete.stop="removeLastTag"
        v-on:keydown="addNew"
        :maxlength="100"
        @keydown.left="handleLeft"
        @keydown.right="handleRight"
        v-on:blur="handleInputBlur"
        v-on:focus="handleInputFocus"
        class="new-tag"
        :class="isInputActive ? 'inputAct':'inputInact'"
      />
      <span v-if="!isInputActive && isShowText" class="text-btn" ref="textBtn">{{ `${innerTags.length}` }}{{$i18.language('个项目')}}</span>
      <div class="inputtag-operation-btn" ref="operationBtn">
        <el-popover
          placement="bottom-end"
          :offset="30"
          width="245"
          :visible-arrow="false"
          :popper-options="popperOptions"
          trigger="hover">
          <div class="precise-query-box">
            <div>
              <el-button size="small" :class="{'active-precise-query': !preciseQuery}" class="sub-confirm-btn" @click="handleChange()">{{ $t('search.fuzzyQuery') }}</el-button>
              <el-button size="small" :class="{'active-precise-query': preciseQuery}" class="sub-confirm-btn" @click="handleChange()">{{ $t('search.preciseQuery') }}</el-button>
            </div>
            <div v-if="id == 'trade-search-buyerNames' || id == 'trade-search-supplierNames' || id == 'trade-detail-search-buyerNames' || id == 'trade-detail-search-supplierNames'" class="precise-query-content">{{$i18.language('使用「精准查询」时，系统将按照完整的词组进行搜索，例如：「NIKE INC」的搜索结果中，将不再包含「NIKE USA INC」')}}</div>
            <div v-else class="precise-query-content">{{$i18.language('如果您切换为「精准查询」方式，系统将按照完整词组进行精准搜索，例如：「paper machine」的搜索结果中，将不再包含 「paper cup machine」')}}</div>
          </div>
          <svg-icon slot="reference" v-show="showPreciseQuery" @click.native.prevent.stop="handleChange()" :name="preciseQuery?'precise-query-active-icon':'precise-query-icon'" class="newIcon"></svg-icon>
        </el-popover>
        <svg-icon v-if="showMoreButton&&showSearchType" @click.native.prevent.stop="handleOpenSet" name="add-more-card" class="newIcon"></svg-icon>
      </div>
    </div>
    <el-popover
      :disabled="optionsList.length <= 0 || !isSelect"
      @after-leave="onHide"
      :class="['popover', notAbsolute?'notAbsolute':'', optionsList.length <= 0?'displayNone':'']"
      trigger="click"
      :width="inputWidth"
      v-model="optionsVisible">
      <div>
        <el-scrollbar wrap-class="el-autocomplete-suggestion__wrap">
          <div class="compare-month-box" v-infinite-scroll="scrollLoad">
            <p class="compare-month-item" v-for="item in optionsList.slice(0, showLength)" :key="item.value" :class="{'active-compare-month-item': innerTags.some(e=>e.value==item.value)}" @mousedown.prevent.stop="changeInnerTags(item)">
              <!-- 产品关键词 -->
              <span v-if="item.value === item.text" class="style_module_item_text">{{ item.value }}</span>
              <!-- hscode -->
              <span v-else class="space-between">
                <span class="text_value">{{ item.value }}</span>
                <span class="text_desc" :title="item.text">{{ item.text }}</span>
              </span>
            </p>
          </div>
        </el-scrollbar>
      </div>
    </el-popover>
    <input-more limitInputType="1" :params="params" :showPreciseQuery="showPreciseQuery" :preciseQuery="preciseQuery" @changeData="changeData" ref="inputMore"></input-more>
  </div>
</template>
<script>
/* eslint-disable */
const validators = {
  email: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  url: new RegExp(/^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isdate: new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/)
};
/* eslint-enable */
import inputMore from '../inputMore.vue';
import debounce from 'throttle-debounce/debounce';
export default {
  name: "InputTag",
  components: {inputMore},
  props: {
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // 是否显示模糊查询
    showPreciseQuery: {
      type: Boolean,
      default: false
    },
    validate: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Function | Object,
      default: ""
    },
    id: {
      type: String,
      default: "multiInputTag"
    },
    addTagOnKeys: {
      type: Array,
      default: function () {
        return [
          13, // Return
          188, // Comma ','
          9 // Tab
        ];
      }
    },
    addTagOnBlur: {
      type: Boolean,
      default: true
    },
    isSelect: { // 是否有下拉展示框
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: -1
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    beforeAdding: {
      type: Function
    },
    showMoreButton: {
      type: Boolean,
      default: true
    },
    // 是否展示NOT/OR/AND
    showSearchType: {
      type: Boolean,
      default: true
    },
    preciseQuery: {
      type: Boolean,
      default: false
    },
    itemTitle: {
      type: String,
      default: ""
    },
    limitInputType: { // 0不做限制 1不支持中文
      type: [Number, String],
      default: 0,
    },
    minInputLength: { // 单次最小输入长度限制
      type: Number,
      default: 0
    },
    maxInputLength: { // 单次最大输入长度限制
      type: Number,
      default: 0
    },
    minInputTips: {
      type: String,
      default: ""
    },
    maxInputTips: {
      type: String,
      default: ""
    },
    // 查询条件，非必填
    params: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    fetchSuggestions: Object,
  },

  data () {
    return {
      inputWidth: 0,
      showLength: 10,
      popperOptions: {
        boundariesElement: 'body'
      },
      checkValue: '',
      optionsList: [],
      newTag: "",
      innerTags: [...this.value],
      isInputActive: false,
      optionsVisible: false,
      isShowText: false, // tagBox宽度大于整个div时显示
      // preciseQuery: false, // 是否模糊查询
      checkedTagIndex: -1, // 选中的tag
      showPopper: false, // 智能感知下拉选项
      hideLoading: false,
      loading: false,
      suggestions:[],
      popperClass: "",
      suggestionDisabled: false, // 智能感知
      notAbsolute: false, // 如果popover层级太低不使用absolute定位
    };
  },

  computed: {
    isLimit: function () {
      return this.limit > 0 && Number(this.limit) === this.innerTags.length;
    }
  },

  watch: {
    value () {
      this.innerTags = [...this.value];
      this.checkedTagIndex = this.innerTags.length
    },
    innerTags: {
      handler() {
        this.getInputWidth()
      },
      immediate: true,
    },
    isInputActive: {
      handler() {
        this.getInputWidth()
        this.inputWidth = this.$refs.MultiInputTag.clientWidth
      }
    },
  },
  mounted() {
    if(this.fetchSuggestions) {
      this.debouncedGetData = debounce(500, this.getData);
    }
  },
  methods: {
    scrollLoad() {
      this.showLength += 5
    },
    onHide() {
      this.showLength = 10
    },
    changeInnerTags(item) {
      // 限制最多10个词组
      if(this.innerTags.length > 9) {
        this.$message.warning(this.$i18.language("最多输入十个词组"))
        return
      }
      let idx = this.showSearchType ? this.innerTags.findIndex(v=>v.value === item.value) : this.innerTags.findIndex(v=>v === item.value)
      if(idx<0) {
        if (this.showSearchType) {
          this.innerTags.push({type: 'or', value: item.value})
        } else {
          this.innerTags.push(item.value)
        }
        this.checkedTagIndex = this.innerTags.length
        this.optionsList = [] 
        this.newTag = ""
        setTimeout(() => {
          this.$refs.tags[this.innerTags.length - 1].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
        }, 0);
      } else {
        this.innerTags.splice(idx, 1)
      }
      this.tagChange();
    },
    // 智能感知下拉框
    getData(queryString) {
      if(!queryString.trim() || !this.newTag.trim()) return this.optionsList = []
      this.loading = true;
      this.optionsVisible = true
      let {method, data, format, notAbsolute} = this.fetchSuggestions
      data = data?data:{}
      method({keyword: queryString, ...data}).then(res=>{
        this.loading = false;
        // this.optionsList格式为[{text: "xxx", value: "xxx"}]如果接口返回不是就传一个格式化函数
        if (format) {
          this.optionsList = format(res.data || [])
        } else {
          this.optionsList = res.data || [];
        }
        if (notAbsolute) {
          this.notAbsolute = true
        } else {
          this.notAbsolute = false
        }
      });
    },
    getInputWidth() {
      this.$nextTick(()=>{
        let MultiInputTag = this.$refs.MultiInputTag ? this.$refs.MultiInputTag.offsetWidth : 0
        let tagsBox = this.$refs.tagsBox ? this.$refs.tagsBox.scrollWidth : 0
        let tagsBoxOffetWidth = this.$refs.tagsBox ? this.$refs.tagsBox.offsetWidth : 0
        let operationBtn = this.$refs.operationBtn ? this.$refs.operationBtn.offsetWidth : 0
        let boxWidth = MultiInputTag - operationBtn - 8
        this.isShowText = (tagsBox > tagsBoxOffetWidth) && !this.isInputActive && this.innerTags.length > 0 ? true : false
        // 移动到最后一个tag的末尾
        if (this.isShowText && this.innerTags.length > 0) {
          setTimeout(() => {
            this.$refs.tags[this.innerTags.length - 1].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
          }, 0);
        }
      })
    },
    inputTagsbox() {
      this.$nextTick(()=>{
        let textBtnWidth = this.$refs.textBtn ? this.$refs.textBtn.offsetWidth : 0
        let inputTagWidth = this.$refs.MultiInputTag ? this.$refs.MultiInputTag.offsetWidth : 0
        let operationBtnWidth = this.$refs.operationBtn ? this.$refs.operationBtn.offsetWidth : 0
        let maxWidth = inputTagWidth - operationBtnWidth - textBtnWidth
        if (this.innerTags.length > 0) {
          return {maxWidth: maxWidth == 0 ? "unset" : maxWidth + "px"}
        }
      })
    },
    focusNewTag () {
      if (this.readOnly || !this.$el.querySelector(`#${this.id} .new-tag`)) {
        return;
      }
      this.$el.querySelector(`#${this.id} .new-tag`).focus();
    },

    handleInputFocus () {
      this.isInputActive = true;
      if(this.checkedTagIndex==-1) {
        this.checkedTagIndex = this.innerTags.length
      }
      let dom = document.querySelector(".top-fixed-box")
      if (dom) {
        dom.style.setProperty('z-index', '102', 'important');
      }
      this.handleSetDom()
    },

    handleInputBlur (e) {
      this.optionsVisible = false
      this.isInputActive = false;
      this.checkedTagIndex = -1
      let dom = document.querySelector(".top-fixed-box")
      if (dom) {
        dom.style.setProperty('z-index', '100', 'important');
      }
      this.addNew(e);
    },

    async addNew (e, isClear) {
      // 如果有限制条数，解决左右键问题
      if(this.isLimit) return e.preventDefault()
      if(!this.newTag.trim()) return
      const keyShouldAddTag = e ? this.addTagOnKeys.indexOf(e.keyCode) !== -1 : true;
      const typeIsNotBlur = e && e.type !== "blur";
      if ((!keyShouldAddTag && (typeIsNotBlur || !this.addTagOnBlur)) || this.isLimit) {
        return;
      }
      if (this.limitInputType == 1 && !/^[0-9]*$/.test(this.newTag)) {
        return this.$message.warning(this.$i18.language('请填写数字的HS编码!'));
      }
      if (this.minInputLength > 0) {
        if (this.newTag.length < this.minInputLength) {
          return this.$message.warning(this.minInputTips);
        }
      }
      if (this.maxInputLength > 0) {
        if (this.newTag.length > this.maxInputLength) {
          return this.$message.warning(this.maxInputTips);
        }
      }
      // 判断去重
      if(keyShouldAddTag || this.addTagOnBlur) {
        let index
        if(this.showSearchType) {
          index = this.innerTags.findIndex(item=>item.value === this.newTag)
        } else {
          index = this.innerTags.findIndex(item=>item === this.newTag)
        }
        if(index>=0) {
          this.$message.warning(this.$t('message.warning.currentKey') + `${this.newTag}` + this.$t('message.warning.condition'))
          return
        }
        // 限制最多10个词组
        if(this.innerTags.length > 9) {
          this.$message.warning(this.$i18.language("最多输入十个词组"))
          return
        }
      }
      let tag = this.beforeAdding ? await this.beforeAdding(this.newTag) : this.newTag;
      const isValid = await this.validateIfNeeded(tag);
      if (tag && isValid && (this.allowDuplicates || this.innerTags.indexOf(tag) === -1)) {
        if(this.showSearchType) {
          this.innerTags.push({type: 'or', value: tag});
        } else {
          this.innerTags.push(tag);
        }

        // 是否退回编辑状态
        if (!isClear) {
          this.newTag = "";
        }
        this.checkedTagIndex = this.innerTags.length
        // this.optionsList = []
        this.tagChange();
        e && e.preventDefault && e.preventDefault();
      }
      this.handleSetDom()
    },
    dblclick(e) {
      if (this.checkedTagIndex > -1) {
        // 如果当前输入框有值
        if (this.newTag && this.newTag.length > 0) {
          this.addNew({...e, keyCode: 13}, true);
        }
        this.newTag = this.innerTags[this.checkedTagIndex].value || this.innerTags[this.checkedTagIndex]
        this.innerTags.splice(this.checkedTagIndex, 1)
        this.checkedTagIndex = this.innerTags.length
        this.tagChange();
      }
    },
    // 触发失焦
    handleBlur() {
      this.$el.querySelector(`#${this.id} .new-tag`).blur();
    },
    // 
    handleSetDom() {
      // 如果超出显示滚动条，则设置滚动到最右侧 
      let dom = document.querySelectorAll(`#${this.id} .input-tags-box`)
      setTimeout(function() {
        if (dom.length > 0) {
          var x = dom[0].scrollWidth; //获取页面最大宽度
          dom[0].scrollLeft = x; //设置滚动条最左方位置
        }
      }, 100)
    },
    validateIfNeeded (tagValue) {
      if (this.validate === "" || this.validate === undefined) {
        return true;
      }

      if (typeof this.validate === "function") {
        return this.validate(tagValue);
      }

      if (typeof this.validate === "string" && Object.keys(validators).indexOf(this.validate) > -1) {
        return validators[this.validate].test(tagValue);
      }

      if (typeof this.validate === "object" && this.validate.test !== undefined) {
        return this.validate.test(tagValue);
      }

      return true;
    },

    remove (index) {
      this.innerTags.splice(index, 1);
      // this.checkedTagIndex = this.innerTags.length
      this.tagChange();
    },
    // 选中标签
    handleCheckTag(tag, index) {
      this.checkedTagIndex = index
    },
    // 数据输入
    handleInput(val) {
      if(this.fetchSuggestions) {
        this.debouncedGetData(this.newTag);
      }
    },
    removeLastTag (e) {
      if(this.checkedTagIndex > -1&&this.checkedTagIndex < this.innerTags.length) {
        const temval = this.innerTags[this.checkedTagIndex].value || this.innerTags[this.checkedTagIndex]
        // 如果当前输入框有值
        if (this.newTag && this.newTag.length > 0) {
          this.addNew({...e, keyCode: 13}, true);
        }
        this.innerTags.splice(this.checkedTagIndex, 1)
        this.checkedTagIndex = this.innerTags.length
        this.tagChange();
        this.newTag = temval
        e && e.preventDefault()
        return
      }
      if (this.checkedTagIndex == this.innerTags.length && e.srcElement.selectionStart == 0) {
        return this.checkedTagIndex = this.innerTags.length - 1
      }
      if (this.newTag) {
        return;
      }
      this.innerTags.pop();
      this.tagChange();
    },
    // 打开弹框
    handleOpenSet() {
      this.$refs.inputMore.open(this.innerTags, this.itemTitle, this.id)
    },
    // 切换是否模糊查询
    handleChange(data) {
      this.$emit("update:preciseQuery", data??!this.preciseQuery);
      this.$emit("changePrecise", this.preciseQuery);
    },
    // 左右键切换
    handleLeft(e) {
      console.log(e.srcElement.selectionStart);
      if (this.$refs.inputtag.selectionStart === 0) {
        if (this.checkedTagIndex > 0) {
          this.checkedTagIndex--;
          this.handleMove()
          e && e.preventDefault()
        }
      }
    },
    handleRight(e) {
      console.log(e.srcElement.selectionStart);
      if (this.checkedTagIndex < this.innerTags.length - 1) {
        this.$refs.inputtag.selectionStart = 0
        this.checkedTagIndex++;
        this.handleMove()
        e && e.preventDefault()
      } else {
        this.checkedTagIndex = this.innerTags.length
      }
    },
    // 左右键移动时移动标签显示位置
    handleMove() {
      if(this.checkedTagIndex < this.innerTags.length) {
        this.$nextTick(() => {
          this.$refs.tags[this.checkedTagIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      }
    },
    tagChange () {
      this.$emit("update:tags", this.innerTags);
      this.$emit("input", this.innerTags);
    },
    // 填写更多内容
    changeData(data, preciseQueryValue) {
      if(this.showPreciseQuery) {
        this.handleChange(preciseQueryValue)
      }
      this.innerTags = data
      this.checkedTagIndex = this.innerTags.length
      this.tagChange()
    },
  }
};
</script>



<style lang="scss" scoped>
.is-disable {
  pointer-events: none;
  cursor: not-allowed;
}
.vue-input-tag-wrapper {
  // background-color: $--background-color-base;
  overflow-x: auto;
  overflow-y:hidden;
  cursor: text;
  text-align: left;
  // -webkit-appearance: textfield;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 26px;
  border: 1px solid $--input-border-color;
  border-radius: $--border-radius-base;
  // border-bottom: 1px solid $--input-border-color;
  padding: 0 4px;
  .new-tag {
    width: 0;
    min-width: 30px;
    // padding-left: 4px;
    &::placeholder {
      color: $--color-text-placeholder;
    }
  }
  .input-tags-box {
    white-space: nowrap;
    overflow-x: auto;
    max-width: 85%;
    &::-webkit-scrollbar {/*滚动条整体样式*/
      width: 0;     /*高宽分别对应横竖滚动条的尺寸*/
      height: 0;
    }
    .input-tag {
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
.newIcon {
  font-size: $--font-size-base;
  cursor: pointer;
  margin-left: 4px;
}
// #trade-search-productDescriptions, #trade-search-hsCodes {
//   width: 96%;
//   padding: 0 4px;
//   .input-tags-box {
//     max-width: 65%;
//     height: 100%;
//     display: flex;
//     align-items: center;
//   }
//   .new-tag {
//     width: 0;
//     min-width: 0;
//     padding-left: 4px
//   }
// }
.vue-input-tag-wrapper .input-tag {
  background-color: #fff;
  border-radius: $--border-radius-base;
  border: 1px solid $--border-primary-color;
  color: $--font-color-primary-6;
  display: inline-block;
   font-size: 14px;
  font-weight: 400;
  margin-right: 4px;
  padding: 0px 4px;
  height: 19px;
  line-height: 19px;
  white-space: nowrap;
  &.select-tag {
    border: 2px solid $--color-active-6;
    color: $--color-active-6;
    .remove {
      color: $--color-active-6;
    }
  }
}

.vue-input-tag-wrapper .input-tag .remove {
  /* display: none; */
  cursor: pointer;
  font-weight: bold;
  color: $--font-color-primary-6;
}

.vue-input-tag-wrapper .input-tag .remove:hover {
  text-decoration: none;
}

#trade-search-productDescriptions, #trade-search-hsCodes {
  width: 96%;
  padding: 0 4px;
  
}

.vue-input-tag-wrapper .new-tag {
  background: transparent;
  border: 0;
  color: $--font-color-primary-6;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  padding: 4px;
  flex-grow: 1;
}
.vue-input-tag-wrapper .inputtag-operation-btn {
  display: flex;
  align-items: center;
}

.vue-input-tag-wrapper.read-only {
  cursor: default;
}
.active-precise-query {
  border-color: $--color-active-6!important;
  color: $--color-active-6!important;
}
.precise-query-content {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid $--border-divide-primary-color;
  font-size: 14px;
  color: $--font-color-text-6;
  line-height: 18px;
}
.popover {
  /deep/ .el-popover {
    padding: 0;
    max-height: 180px;
    box-sizing: border-box;
    margin-top: 1px;
  }
}
.notAbsolute {
  /deep/ .el-popover {
    position: relative !important;
  }
}
.displayNone {
  display: none;
}
.text-btn {
  margin-left: 4px;
  white-space: nowrap;
  cursor: text;
}
.inputAct {
  min-width: 20px;
  padding: 0 !important;
}
.inputInact {
  min-width: 0 !important;
  padding: 0 !important
}
/deep/ .el-autocomplete-suggestion__wrap {
  padding: 0 !important;
  max-height: 180px;
}
.compare-month-box {
  overflow: hidden;
  // max-height: 183px;
  // overflow-y: scroll;
  // &::-webkit-scrollbar {
  //   width: 5px; /* Chrome Safari */
  // }
  // &::-webkit-scrollbar-thumb {
  //   background: rgba(144, 147, 153, 0.3); // 滑块颜色
  //   border-radius: 5px; // 滑块圆角
  // }
  // &::-webkit-scrollbar-thumb:hover {
  //   background: rgba(144, 147, 153, 0.5); // 鼠标移入滑块hover
  // }
  .compare-month-item {
    padding: 8px 7px;
    border-bottom: 1px solid $--border-color-primary-6;
    line-height: 14px;
    // padding-right: 40px;
    cursor: pointer;
    &:last-child {
      border: 0;
    }
    &:hover {
      background: #eaecee;
    }
    &.active-compare-month-item {
      border-bottom: 1px solid $--color-primary-6;
      background: #EBF8FF;
      position: relative;
      &::after {
        position: absolute;
        right: 20px;
        font-family: 'element-icons';
        content: "\e6da";
        font-size: 12px;
        font-weight: bold;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: $--color-primary-6;
        top: 8px;
      }
    }
    .space-between {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .text_value {
        flex: 1;
        white-space: nowrap;
      }
      .text_desc {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover {
  
        }
      }
    }
  }
}
</style>

